import { configureStore } from '@reduxjs/toolkit'
import StepSlice from '../Var/CoachmarkVar'
export default configureStore({
  reducer: {
    Step: StepSlice,
  },
})